import { Control, FieldValues, useController, UseControllerProps } from 'react-hook-form'
import { Checkbox, CheckboxProps } from '../../Checkbox'

export type ControlledCheckboxProps<T extends FieldValues> = UseControllerProps<T> & Partial<CheckboxProps>

export function ControlledCheckbox<T extends FieldValues>({
  control,
  name,
  rules,
  defaultValue,
  ...rest
}: ControlledCheckboxProps<T>) {
  const { field, fieldState } = useController({
    control,
    name,
    rules,
    defaultValue,
  })

  return (
    <>
      <Checkbox {...rest} onChange={field.onChange} checked={field.value} />
      {!!fieldState.error?.message && <span className={'text-red-500'}>{fieldState.error?.message}</span>}
    </>
  )
}
